export default __webpack_public_path__ + "static/media/13-seethrough.78a23465.png";